import React from 'react';
import PropTypes from "prop-types";

class ScreenSwitcher extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        let data = null;
        if (Array.isArray(this.props.children)) {
            for (let i = 0; i < this.props.children.length; i++) {
                if (this.props.children[i].key === this.props.screen) {
                    data =
                        <div key={this.props.screen} className='ScreenSwitcherContent'>{this.props.children[i]}</div>;
                }
            }
        } else {
            data = this.props.children;
        }
        return (
            <div className='ScreenSwitcher'>
                {data}
            </div>
        )
    }
}

ScreenSwitcher.propTypes = {
    screen: PropTypes.string.isRequired,
    mainScreen: PropTypes.string,
};

export default ScreenSwitcher;